import siteInfo from '../../content/info.js';
export default siteInfo;
